import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { ArrowLeft } from 'react-feather';
import './button-group.scss';

function ButtonGroup({
  primary = 'Lưu',
  secondary = 'Hủy',
  primaryOnClick,
  secondaryOnClick,
  className,
  primaryDisabled = false,
  isBack = false,
}) {
  const isBackButton = isBack || secondary === 'Quay lại';

  return (
    <div className={`${className || ''} d-flex justify-content-center`}>
      <Button
        className="mr-1 px-3"
        size="lg"
        color="primary"
        onClick={primaryOnClick}
        disabled={primaryDisabled}
      >
        {primary}
      </Button>
      <Button
        color="none"
        size="lg"
        className={isBackButton ? 'button-group__back px-3' : 'bg-blur-gray color-white px-3'}
        onClick={secondaryOnClick}
      >
        {isBackButton && <ArrowLeft size={16} className="mr-50" style={{ strokeWidth: 2.5 }} />}
        {secondary}
      </Button>
    </div>
  );
}

ButtonGroup.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  primaryOnClick: PropTypes.func,
  secondaryOnClick: PropTypes.func,
  className: PropTypes.string,
  primaryDisabled: PropTypes.bool,
  isBack: PropTypes.bool,
};

export default ButtonGroup;
